












































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action } from "vuex-class";

import TransitionSlide from "@/components/ui/transitions/TransitionSlide.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

@Component({
  components: { TransitionSlide },
  filters: {
    ...capitalizeFilter
  }
})
export default class AppTopNavbarBanner extends Vue {
  @Action("auth/logout") logout!: () => void;

  i18nMessageKeyEnum = I18nMessageKey;
}
